export const VIEW_LABELS = {
  dashboard: 'Panel',
  gyms: 'Gimnasios',
  clubs: 'Clubs',
  productos: 'Tienda / Productos',
  usuarios: 'Usuarios',
  entrenadores: 'Entrenadores',
  afiliaciones: 'Afiliaciones',
  'valores-afiliacion': 'Valores de afiliación',
  eventos: 'Eventos',
  participantes: 'Lista de participantes',
  records: 'Récords',
  marcas: 'Actualizar marcas personales',
  rankings: 'Rankings',
};

export function getViewLabel(viewKey) {
  return VIEW_LABELS[viewKey] || viewKey;
}
